import { render, staticRenderFns } from "./RecentlyViewedModal.vue?vue&type=template&id=b564643c"
import script from "./RecentlyViewedModal.vue?vue&type=script&lang=js"
export * from "./RecentlyViewedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports